export default class FieldExtensions {
    static getFieldValue(field) {
        if (field.items) {
            let val = field.items.find(x => x.value === field.value)
            if (typeof val === 'object') {
                return val.text
            }
        }

        return field.value
    }
}